import React from "react";
import icon_seguridad from "../../assets/10_POSVENTA/01_Servicios exclusivos/Seguridad.svg";
import icon_confianza from "../../assets/10_POSVENTA/01_Servicios exclusivos/Confianza.svg";
import icon_eficiencia from "../../assets/10_POSVENTA/01_Servicios exclusivos/Eficiencia.svg";
import icon_comodidad from "../../assets/10_POSVENTA/01_Servicios exclusivos/Comodidad.svg";
import icon_conveniencia from "../../assets/10_POSVENTA/01_Servicios exclusivos/Conveniencia.svg";

/*eslint-disable */

interface PromesaComponentProps {
  data: any;
  benefits: any;
}

declare const window: any;
const PromesaComponent: React.FC<PromesaComponentProps> = ({data, benefits}) => {
  return (
    <div className="promesa-posventa-finanzas-container">
      <div className="title-promesa-posventa-finanzas-container">
        {data.finance_title}
      </div>
      <div className="text-promesa-posventa-finanzas-container">
        {data.finance_description}
      </div>
      <div className="opciones-promesa-posventa-finanzas-container">
        <div className="master-opcion-promesa-posventa-finanzas-container">
          {data.benefit_title}
        </div>
        {benefits?.map((item: any, index: number) => (
          <div className="opcion-promesa-posventa-finanzas-container">
            <img src={`https://manager.hyundaicolombia.co/${item?.media?.url}`} alt="Icono de Confianza" className="icon-opcion-promesa-posventa-finanzas-container" />
            <div className="title-opcion-promesa-posventa-finanzas-container">{item.title}</div>
            <div className="text-opcion-promesa-posventa-finanzas-container">{item.description}</div>
          </div>
        ))}
      </div>
      <a href={data.benefit_url} target="_blank" className={`link-promesa-posventa-finanzas-container`}>{data.benefit_url_text}</a>
    </div>
  );
};

export default PromesaComponent;
